<template>
  <div class="login-components">
    <div class="login-module">
      <div class="main">
        <div class="sgs-login-tab-area">
          <div class="sgs-login-tab login-tab-mobile-sms" :class="{ 'sgs-tab-select': !isLoginByPassword }"
            @click="toggleTab(false)">验证码登录</div>
          <div class="sgs-login-tab login-tab-account-password" :class="{ 'sgs-tab-select': isLoginByPassword }"
            @click="toggleTab(true)">密码登录</div>
        </div>
        <div class="login-password" v-if="isLoginByPassword">
          <el-form :model="form" :rules="rules" ref="ruleForm1">
            <el-form-item prop="accountNo">
              <el-input :placeholder="noEmail ? '请输入手机号' : '请输入手机号/电子邮箱'" v-model="form.accountNo"
                maxlength="80"></el-input>
            </el-form-item>
            <el-form-item prop="userPwd">
              <el-input type="password" placeholder="请输入密码" v-model="form.userPwd" show-password
                maxlength="20"></el-input>
            </el-form-item>
            <el-form-item prop="imageCode" class="verify-code-item" v-if="needImgCode">
              <el-input placeholder="图片验证码" class="verify-code-input" v-model="form.imageCode"></el-input>
              <img align="absmiddle" id="membervocde"
                :src="apiUrl + '/ticCenter/business/api.v1.center/verify/getImageCode?t=' + imgCodeTime" alt="验证码"
                width="100" height="30" @click="getImageCode">
              <span class="change-img-code" @click="getImageCode">换一个</span>
            </el-form-item>
            <div :class="{ 'tips': true, 'tips-code': needImgCode }">忘记密码？用<span
                @click="toggleTab(false)">验证码登录</span>试试
            </div>
            <el-button class="submit-btn" type="primary" @click="handleSubmit('ruleForm1')"
              :loading="loading">登录</el-button>
            <el-form-item class="find-password">
              <a :href="originList.member + '/findpwd'">找回密码</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="login-code" v-if="!isLoginByPassword">
          <el-form :model="form" :rules="rules" ref="ruleForm2">
            <el-form-item prop="accountNo">
              <el-input :placeholder="isByPhone ? '请输入手机号' : '请输入电子邮箱'" v-model="form.accountNo"
                maxlength="80"></el-input>
            </el-form-item>
            <el-form-item prop="verifyCode" class="verify-item">
              <el-input placeholder="请输入验证码" class="getCode-btn" v-model="form.verifyCode">
                <span slot="suffix" @click="sendCode" v-loading="codeLoading">{{ timer ? `${seconds}s后再次发送` : isByPhone
                  ?
                  '获取短信验证码' : '获取邮件验证码' }}</span>
              </el-input>
            </el-form-item>
            <div class="email-tips" v-if="!isByPhone">请登录邮箱查收验证码邮件</div>
            <div class="register-checkbox">
              <el-checkbox v-model="checkRegister"></el-checkbox>
              <span class="text">阅读并同意<em class="activeColr" @click="setTipsVisible(true)">注册</em></span>及<a
                class="activeColr" href="https://www.sgsgroup.com.cn/zh-cn/privacy-at-sgs"
                target="_blank">隐私条款</a>，SGS保护您的隐私。
            </div>
            <el-button class="submit-btn" type="primary" @click="handleSubmit('ruleForm2')"
              :loading="loading">登录/注册</el-button>
            <div class="tips">
              如未收到验证码，请检查账号
              <span style="float:right;cursor: pointer" @click="toggleLogin" v-if="!noEmail">{{ isByPhone ? '邮箱登录' :
                '手机号登录' }}</span>
            </div>
          </el-form>
        </div>
      </div>
      <div class="side">
        <img class="logo" src="../../assets/images/login-logo.png" alt="">
        <div class="title">登录免费下载</div>
        <div class="text-list">
          <div>各国各行标准解读</div>
          <div>全球市场召回案例</div>
          <div>贸易保障解决方案</div>
          <div>实验室实践及案例</div>
        </div>
        <span class="more-button" @click="moreTips">查看更多 ></span>
        <img class="text-icon" src="../../assets/images/text-icon.png" alt="">
      </div>
    </div>
    <register-terms v-if="tipsVisible" @setTipsVisible="setTipsVisible"></register-terms>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { loginPwd, loginReg, getCodeByValid, loginByPassword, tencentCaptchaApi } from 'src/request/apis';
import RegisterTerms from './RegisterTerms';
import { tokenKey } from '../../utils/index'
import { host } from "src/config";
import { axiosAjax } from './../../request/indexB'

export default {
  name: "TicLoginMerge",
  props: {
    isRedirect: {
      type: Number,
      default: 1
    },
    successCallback: {
      type: Function
    },
    parameter: {
      type: Object,
      default: () => { }
    },
    env: {
      type: String,
      default: 'local',
    },
    noEmail: {
      type: Boolean,
      default: false
    },
    memberUrl: {
      type: String,
      default: ''
    }
  },
  components: { RegisterTerms },
  data() {
    const validateName = (rule, value, callback) => {
      if (!this.isLoginByPassword) {
        if (this.isByPhone) {
          validatePhone(rule, value, callback)
        } else {
          validateEmail(rule, value, callback)
        }
        return
      }
      if (this.noEmail) {
        validatePhone(rule, value, callback)
        return
      }
      const phoneReg = this.phoneReg
      const mailReg = this.mailReg
      if (!this.form.accountNo) {
        return callback(new Error('请输入手机号或邮箱'))
      } else if (!phoneReg.test(this.form.accountNo) && !mailReg.test(this.form.accountNo)) {
        return callback(new Error('请输入正确的手机号或邮箱'))
      } else {
        return callback()
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (!this.form.accountNo) {
        return callback(new Error('请输入手机号'))
      } else if (!this.phoneReg.test(this.form.accountNo)) {
        return callback(new Error('请输入正确的手机号'))
      } else {
        return callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (!this.form.accountNo) {
        return callback(new Error('请输入邮箱'))
      } else if (!this.mailReg.test(this.form.accountNo)) {
        return callback(new Error('请输入正确的邮箱'))
      } else {
        return callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (this.needImgCode && !value) {
        return callback(new Error('请输入验证码'))
      } else {
        return callback()
      }
    }
    return {
      host: host(this.env),
      apiUrl: host(this.env).javaUrl,
      level1Path: host(this.env).sgsonlineUrl,
      domain: host(this.env).domain,
      mdoUrl: host(this.env).mdoUrl,
      imgCodeTime: new Date().getTime(),
      phoneReg: /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/,
      mailReg: /^[a-zA-Z0-9_.-]+@\w+([-.][A-Za-z0-9]+)*\.\w+([-.][A-Za-z0-9]+)*$/,
      isLoginByPassword: false,
      needImgCode: false,
      codeLoading: false,
      tipsVisible: false,
      timer: null,
      seconds: 59,
      checkRegister: false,
      loading: false,
      nextOrigin: '',
      nextPath: '',
      originList: {
        www: host(this.env).sgsonlineUrl,
        store: host(this.env).storeUrl,
        mall: host(this.env).mallUrl,
        ind: host(this.env).indUrl,
        member: host(this.env).memberUrl
      },
      form: {},
      rules: {
        accountNo: [
          { validator: validateName },
        ],
        userPwd: [{ required: true, message: '请输入密码' }],
        imageCode: [{ validator: validateCode }],
        verifyCode: [{ required: true, message: '请输入验证码' }],
      },
      isCodeOpen: '1',
      captchaAppId: '192302431',
      isByPhone: true
    }
  },
  watch: {
    memberUrl: {
      handler(val) {
        if (val) this.originList.member = val
      },
      immediate: true
    }
  },
  created() {
    /* 引用腾讯盾SDK */
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
    document.body.appendChild(s);
  },
  mounted() {
    this.nextOrigin = this.$route.query.next_origin
    // this.nextPath = this.$route.query.next_path
    const search = window.location.search
    this.nextPath = decodeURIComponent(
      search.substr(search.indexOf('next_path') + 10, search.length)
    )
    // this.originList.member = location.origin
  },
  methods: {
    toggleLogin() {
      this.isByPhone = !this.isByPhone
      this.$nextTick(() => {
        this.$refs.ruleForm2.clearValidate()
      })
    },
    /* 查看更多 */
    moreTips() {
      this.$message.warning('请登录后查看更多')
    },
    /* 切换登录方式，验证码登录还是密码登录 */
    toggleTab(isLoginByPassword) {
      this.isLoginByPassword = isLoginByPassword
      this.$nextTick(() => {
        const formKey = isLoginByPassword ? 'ruleForm1' : 'ruleForm2'
        this.$refs[formKey].clearValidate()
      })
    },
    /* 获取图片验证码 */
    getImageCode() {
      this.imgCodeTime = new Date().getTime()
    },
    /* 
      提交登录动作
      formKey： ruleForm1 密码登录
      formKey： ruleForm2 验证码登录
    */
    handleSubmit(formKey) {
      this.$refs[formKey].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.isLoginByPassword) {
            this.loginByPassword()
          } else {
            this.loginVerify()
          }
        } else {
          return false
        }
      })
    },
    /* 密码登录接口 */
    loginByPassword() {
      let arr = {
        accountType: 'phone',
        accountNo: this.form.accountNo,
        userPwd: this.form.userPwd,
        imageCode: this.form.imageCode,
        regFrom: location.href
      }
      // axiosAjax(this.apiUrl + '/ticSso/business/api.v1.sso/account/login', Object.assign(arr, this.parameter)).then(res => {
      //   if (res.resultCode === '0') {
      //     this.login(res)
      //   } else {
      //     this.$message.error(res.resultMsg)
      //     this.loading = false
      //   }
      // }).catch(e => {
      //   this.loading = false
      //   if (e && e.resultCode === '1207') {
      //     this.getImageCode()
      //     this.needImgCode = true
      //     return
      //   }
      //   if (this.needImgCode) {
      //     this.getImageCode()
      //   }
      // })

      loginPwd(Object.assign(arr, this.parameter), this.host.mdoUrl)
        .then((res) => {
          if (res.resultCode === '0') {
            this.login(res)
          } else {
            this.loading = false
          }
        })
        .catch((e) => {
          this.loading = false
        })
    },
    /* 登录成功之后的操作 */
    login(res) {
      this.loading = false
      this.token = res.data.token
      const token = res.data.token
      const count = res.data.count || 0
      if (location.origin.includes('.sgsonline.com.cn') || location.origin.includes('.sgsmall.com.cn')) {
        Cookies.set(tokenKey, token, {
          domain: '.sgsonline.com.cn',
          expires: 7,
          sameSite: 'None',
          secure: true
        })
        Cookies.set(tokenKey, token, {
          domain: '.sgsmall.com.cn',
          expires: 7,
          sameSite: 'None',
          secure: true
        })
        if (!Cookies.get('CARTNUMBER')) {
          Cookies.set('CARTNUMBER', count, { domain: '.sgsonline.com.cn' })
          Cookies.set('CARTNUMBER', count, { domain: '.sgsmall.com.cn' })
        }
      } else {
        Cookies.set(tokenKey, token, { expires: 7, sameSite: 'None', secure: true })
        if (!Cookies.get('CARTNUMBER')) {
          Cookies.set('CARTNUMBER', count)
        }
      }
      if (this.isRedirect === 1) {
        this.successCallback()
      } else {
        const url = this.nextOrigin
          ? this.originList[this.nextOrigin] + this.nextPath
          : this.level1Path
        location.replace(url)
      }
    },
    /* 验证码登录 */
    loginVerify() {
      if (!this.checkRegister) {
        this.loading = false
        this.$alert('同意注册条款和隐藏协议后才可以继续提交', '', { confirmButtonText: '确定', center: true });
        return
      }
      let arr = {
        verifyCode: this.form.verifyCode,
        verifyNumber: this.form.accountNo,
        verifyType: 3,
        verifyMode: this.phoneReg.test(this.form.accountNo) ? 'phone' : 'email',
        accountType: this.phoneReg.test(this.form.accountNo) ? 'phone' : 'email',
        accountNo: this.form.accountNo,
        regFrom: location.href,
        regSource: '',
        regMode: 'USER_REG',
      }
      loginReg(Object.assign(arr, this.parameter), this.host.mdoUrl)
        .then((res) => {
          if (res.resultCode === '0') {
            this.login(res)
          } else {
            this.loading = false
          }
        })
        .catch((e) => {
          this.loading = false
        })
    },

    /* 获取短信或邮箱验证码 */
    sendCode() {
      if (this.codeLoading || !!this.timer) {
        return
      }
      if (!this.form.accountNo) {
        this.$message.error(this.isByPhone ? '请输入手机号' : '请输入邮箱')
        return
      }
      if (this.isByPhone && !this.phoneReg.test(this.form.accountNo)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.isByPhone && !this.mailReg.test(this.form.accountNo)) {
        this.$message.error('请输入正确的邮箱')
        return
      }
      if (this.phoneReg.test(this.form.accountNo)) {
        this.showCaptcha()
      } else {
        this.toSendCode()
      }
    },
    /* 腾讯安全盾调用方 */
    showCaptcha() {
      try {
        let captcha = new window.TencentCaptcha(this.captchaAppId, (res) => {
          if (res.ret === 0) {
            const data = {
              ticket: res.ticket,
              randstr: res.randstr,
              captchaAppId: this.captchaAppId
            }
            this.toSendCode(data)
          } else if (res.ret === 2) {
            // 用户主动关闭验证码
          }
        });
        captcha.show();
      } catch (e) {
        this.toSendCode()
      }

    },
    toSendCode(txData) {
      this.codeLoading = true
      const data = Object.assign({
        projectName: 'ticMember',
        verifyNumber: this.form.accountNo,
        verifyMode: this.phoneReg.test(this.number) ? 'phone' : 'email',
        verifyType: 3,
        tencentVerify: txData
      }, {})
      getCodeByValid(data, this.host.mdoUrl)
        .then((res) => {
          this.codeLoading = false
          if (res.resultCode === '0') {
            this.timer = setInterval(() => {
              if (this.seconds > 1) {
                this.seconds -= 1
              } else {
                clearInterval(this.timer)
                this.timer = null
                this.seconds = 59
              }
            }, 1000)
          } else {
            this.$message.error(res.resultMsg || '该手机号未注册，请先注册')
          }
        })
        .catch((e) => {
          this.codeLoading = false
        })
    },
    setTipsVisible(val) {
      this.tipsVisible = val
    }
  },
}
</script>

<style lang="scss">
.email-tips {
  font-size: 14px;
  color: #FF6600;
  line-height: 14px;
}

.login-module {
  display: flex;
  justify-content: space-between;
  height: 460px;
  width: 900px;
  overflow: hidden;

  .activeColr {
    color: #CA4300;
  }


  .main {
    width: 540px;
    height: 460px;
    background: #fff;
    border-radius: 12px;
    padding: 50px;
    box-sizing: border-box;

    .sgs-login-tab-area {
      display: flex;
      font-size: 18px;
      color: #333333;
      line-height: 20px;
      margin-bottom: 50px;

      .sgs-login-tab {
        margin-right: 30px;
        cursor: pointer;

        &.sgs-tab-select {
          font-size: 20px;
          font-weight: bold;
          position: relative;

          &:after {
            content: "";
            position: absolute;
            width: 100%;
            height: 3px;
            bottom: -16px;
            left: 0;
            background: #CA4300;
          }
        }
      }
    }

    .submit-btn {
      background: #ca4300;
      border-radius: 4px;
      height: 50px;
      width: 100%;
      font-size: 18px;
    }

    .login-password {
      .tips {
        text-align: right;
        font-size: 14px;
        color: #878787;
        padding: 25px 0;

        span {
          color: #CA4300;
          cursor: pointer;
        }

        &.tips-code {
          padding: 5px 0;
        }
      }

      .find-password {
        padding-top: 20px;

        a {
          color: #878787;
          font-size: 14px;
        }
      }
    }

    .login-code {
      .getCode-btn {
        .el-input__suffix-inner {
          color: #CA4300;
          padding-right: 23px;
          cursor: pointer;
        }
      }

      .register-checkbox {
        font-size: 14px;
        color: #878787;
        line-height: 1;
        margin-bottom: 20px;
        margin-top: 40px;

        .text {
          padding-left: 10px;
        }

        em {
          font-style: normal;
          cursor: pointer;
        }
      }

      .tips {
        font-size: 14px;
        color: #878787;
        padding-top: 20px;
      }
    }

    .verify-code-item {

      .change-img-code,
      img {
        cursor: pointer;
      }
    }

    .verify-code-input {
      width: 200px;
      margin-right: 95px;
    }
  }

  .side {
    width: 344px;
    height: 460px;
    background: #fff;
    border-radius: 12px;
    display: flex;
    align-items: center;
    flex-direction: column;

    .logo {
      width: 135px;
      height: 59px;
      margin-bottom: 40px;
      margin-top: 50px;
    }

    .title {
      padding-left: 20px;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 1;
      margin-bottom: 30px;
    }

    .text-list {
      font-size: 14px;
      color: #7D7D7D;
      line-height: 30px;
      margin-bottom: 20px;

      div {
        padding-left: 14px;
        position: relative;

        &:before {
          content: "";
          position: absolute;
          width: 4px;
          height: 4px;
          background: #CA4300;
          left: 0;
          top: 13px;
        }
      }
    }

    .more-button {
      font-size: 14px;
      color: #CA4300;
      line-height: 1;
      cursor: pointer;
    }

    .text-icon {
      width: 165px;
      height: 13px;
      margin-top: 50px;
    }
  }
}
</style>